"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClickableCard = void 0;
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var card_module_scss_1 = __importDefault(require("../../Card/card.module.scss"));
var Utility_1 = require("../../Icons/Utility");
var clickable_card_module_scss_1 = __importDefault(require("./clickable-card.module.scss"));
var defaultProps = {
    as: 'button',
    showNavigationIcon: true
};
// eslint-disable-next-line no-redeclare, import/export
var ClickableCard = function (_a) {
    var _b = _a.as, Component = _b === void 0 ? defaultProps.as : _b, _c = _a.showNavigationIcon, showNavigationIcon = _c === void 0 ? defaultProps.showNavigationIcon : _c, children = _a.children, className = _a.className, intrinsicElementAttributes = __rest(_a, ["as", "showNavigationIcon", "children", "className"]);
    return (react_1.default.createElement(Component, __assign({ className: (0, classnames_1.default)(card_module_scss_1.default.card, clickable_card_module_scss_1.default['clickable-card'], className) }, intrinsicElementAttributes),
        children,
        showNavigationIcon && (react_1.default.createElement(Utility_1.NavigateNext, { className: clickable_card_module_scss_1.default['clickable-card__chevron'], size: "large", ariaHidden: true }))));
};
exports.ClickableCard = ClickableCard;
exports.ClickableCard.defaultProps = defaultProps;
